<template>
    <div class="wizard__wrap wizard__wrap--invoices">
        <div class="wizard__block">
            <div class="row">
                <div class="logo logo--after">{{ agencyName }}</div>
            </div>
            <div class="wizard__block-title">Do you have another service?</div>

            <div class="wizard__block-sow">
                <div class="row jus-c--center">
                    <div class="col-lg-12 col-md-12">
                        <div
                            class="form-field form-field--radiobutton"
                            style="text-align: center"
                        >
                            <input
                                type="radio"
                                name="is_has_new_upsell"
                                id="is_has_new_upsell_yes"
                                :checked="isHasNewService"
                                @change="isHasNewService = true"
                            />
                            <label
                                style="width: 70px"
                                for="is_has_new_upsell_yes"
                                >Yes</label
                            >
                        </div>
                        <div
                            class="form-field form-field--radiobutton"
                            style="text-align: center"
                        >
                            <input
                                type="radio"
                                name="is_has_new_upsell"
                                id="is_has_new_upsell_no"
                                :checked="isHasNewService === false"
                                @change="isHasNewService = false"
                            />
                            <label
                                style="width: 70px"
                                for="is_has_new_upsell_no"
                                >No</label
                            >
                        </div>
                    </div>
                </div>
            </div>

            <div class="wizard__block-nav">
                <button
                    @click="
                        () =>
                            onChangeSection(
                                SECTIONS.UPSELL,
                                SECTIONS.DO_YOU_HAVE_SERVICE
                            )
                    "
                    class="btn btn--prev btn--white"
                >
                    Previous
                </button>
                <button @click="onNextPage" class="btn btn--prev btn--white">
                    Next
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { scrollToTop } from "../../../helpers/_scrollToTop";
import { SECTIONS } from "../consts";

export default {
    name: "Wizard_Do_You_Have_New_Service",
    props: ["onChangeSection"],
    data() {
        return {
            SECTIONS,
            isHasNewService: null,
        };
    },

    mounted() {
        scrollToTop();
    },

    computed: {
        prevSection() {
            return this.$store.getters.getPrevComponent;
        },
        currentBrand() {
            return this.$store.getters.getCurrentBrandName;
        },
        agencyName() {
            return this.$store.getters.getAgencyName;
        },
        upsellIndex() {
            return this.$store.getters.getCurrentIndexUpsell;
        },
    },

    methods: {
        onNextPage() {
            if (
                this.isHasNewService === undefined ||
                this.isHasNewService === null
            ) {
                this.$toast.error("Please select an answer");
                return;
            }

            if (this.isHasNewService) {
                this.onChangeSection(
                    SECTIONS.UPSELL,
                    SECTIONS.DO_YOU_HAVE_SERVICE
                );
                this.$store.commit("setIndexUpsell", this.upsellIndex + 1);
                return;
            }

            this.onChangeSection(
                SECTIONS.DO_YOU_HAVE_UPSELL,
                SECTIONS.DO_YOU_HAVE_SERVICE
            );
        },
    },
};
</script>
